module.exports = __webpack_public_path__ + "media/images/admin/icons/mic-b386a135fc6f50f1b194adc073216ed7.svg";